// Cross-stack log correlation. Attaches the stable per-tab session id to
// every API request as a Sentry `baggage` entry (`sentry-session_id=<id>`),
// matching the convention iOS already uses. Django's SentryTracingMiddleware
// parses it, binds it to structlog contextvars, and every backend log line for
// the request carries `session_id` — greppable in Loki via
// `{app="qopilot"} | json | session_id="<id>"`.
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { getSentrySessionId } from '@/lib/sentry'

export function applySessionBaggage(config: InternalAxiosRequestConfig) {
  const sessionId = getSentrySessionId()
  if (sessionId && sessionId !== 'server' && sessionId !== 'unavailable') {
    const entry = `sentry-session_id=${sessionId}`
    const existing = config.headers.get('baggage')
    config.headers.set('baggage', existing ? `${existing},${entry}` : entry)
  }
  return config
}

/** Register the session-baggage interceptor on an axios instance. */
export function registerSessionBaggage(instance: AxiosInstance) {
  instance.interceptors.request.use(applySessionBaggage)
}
